angular.module(NgAppName).directive('crDropdownFilter', ['$timeout', '$rootScope', 'PubSub', function($timeout, $rootScope, PubSub){
	return {
		restrict: 'A',
		scope: true,
		link: function(scope, element, attrs) {
			var type = attrs.selectType;
			var isMultiSelect = type === 'single' ? false : true;
			var isAutoSubmit = attrs.autoSubmit == 'no' ? false : true;

			var toggle = element[0].querySelector('.cr_dropdownfilter_monitor');

			scope.uuid = Core.uuid();
			scope.opened = false;
			var __setDefault = function() {
				if (isMultiSelect) {
					return;
				}

				angular.forEach(scope.filter.options, function(option) {
					if (option.active === true) {
						scope.activeOption = option;
					}
				});

				if (attrs.defaultOption) {
					scope.defaultOption = {
						label: attrs.defaultOption || null,
						active: !scope.activeOption
					};

					if (!scope.activeOption) {
						scope.activeOption = scope.defaultOption;
					}
				} else if (!scope.activeOption) {
					scope.filter.options[0].active = true;
					scope.activeOption = scope.filter.options[0];
				}
			};

			var getActiveNumber = function() {
				var activeNumber = 0;
				angular.forEach(scope.filter.options, function(opt) {
					if (opt.active) {
						activeNumber++;
					}
				});

				return activeNumber;
			};

			var __setTitle = function() {
				if (isMultiSelect) {
					var optionsNumber = scope.filter.options.length;
					var activeNumber = getActiveNumber();
					if (activeNumber == 0 || activeNumber == optionsNumber) {
						scope.filterName = 'All ' + scope.filter.name
					} else {
						scope.filterName = scope.filter.name + ' <span class="count">(' + activeNumber + ' of ' + optionsNumber + ')</span>';
					}
				} else {
					if (scope.activeOption) {
						scope.filterName = scope.activeOption.label;
					}
				}
			};

			var __fireChange = function(time) {
				// always set the page to 1 when the user changed the filter.
				if (scope.formData && scope.formData.pagination) {
					scope.formData.pagination.currentPage = 1;
				} else if (scope.pagination) {
					scope.pagination.currentPage = 1;
				}
				scope.$emit('changeSearchParameters', scope.filter.options);
			};

			scope.$watch('filter', function() {
				if (!scope.filter) return;
				__setDefault();
				__setTitle();
			});

			scope.toggleList = function($event) {
				$event && $event.preventDefault();
				scope.opened = !scope.opened;
			};

			scope.toggleOption = function(option){
				if (scope.loadingResults) {
					return;
				}

				if (isMultiSelect) {
					option.active = !option.active;
				} else {
					if (scope.activeOption) {
						scope.activeOption.active = false;
					}

					option.active = true;
					scope.activeOption = option;

					// close the list (only single selection)
					scope.toggleList();
					// put back focus to toggle
					toggle.focus();
				}

				__setTitle();

				if (isAutoSubmit) {
					__fireChange();
				}
			};

			scope.reset = function() {
				scope.toggleOption(scope.defaultOption);
				scope.opened = false;
			};

			PubSub.subscribe('resetDropdownFilter', function(filters) {
				if (filters) {
					angular.forEach(filters, function(filter) {
						if (filter.name === scope.filter.name) {
							scope.filter = filter;
							__setDefault();
							__setTitle();
						}
					});
				} else {
					scope.reset();
				}
			});
		}
	};
}]);
